export function initializeSearch() {
    var closeButton = document.getElementById('search-close-button');
    var searchButton = document.getElementById('main-search-button');

    // 0 = closed and 1 is open.
    var currentState = 0;

    searchButton.onclick = function () {
        if (currentState === 0) {
            showSearchOverlay(currentState);
            currentState = 1;
        }
    }
    closeButton.onclick = function () {
        if (currentState === 1) {
            showSearchOverlay(currentState);
            currentState = 0;   
        }
    }
}
function showSearchOverlay(state) {
    var overlay = document.getElementsByClassName("searchblock")[0];

    if (state === 0) {
        animateCloseButton(state);

        overlay.style.display = 'flex';
        window.setTimeout(function () {
            overlay.style.opacity += 1.0;
        }, 50);
    } else {
        animateCloseButton(state);

        window.setTimeout(function () {
            overlay.style.opacity = 0.0;
        }, 550);
        window.setTimeout(function () {
            overlay.style.display = 'none';
        }, 2100);
    }
} 

function animateCloseButton(state) {    
    var row1 = document.getElementById('srow1');
    var row2 = document.getElementById('srow2');

    if (state === 0) {
        window.setTimeout(function () {
            row1.style.transform += 'rotate(45deg)';
            row2.style.transform += 'rotate(-45deg)';
        }, 750);
    } else {
        window.setTimeout(function () {
            row1.style.transform = 'rotate(0deg)';
            row2.style.transform = 'rotate(0deg)';
        }, 50);
    }
}